export default __webpack_public_path__ + "static/media/IMG_4998.4262197a.png";